import React, { ErrorInfo } from 'react';

import { reportUIError } from 'src/dataLayer/remoteData/rollbar';
import { ErrorScreen } from './ErrorScreen';
import {
  ErrorBoundaryArgumentsType,
  ErrorBoundaryPropsType,
  ErrorBoundaryStateType
} from './types';

// default fallback is to reload the current location
// can be overridden by passing it to the HOC to e.g. re-fetch API info
const defaultFallback = (): void => window.location.reload();

export const withErrorBoundary = ({
  ErrorComponent = ErrorScreen,
  componentTitle,
  fallbackAction = defaultFallback
}: ErrorBoundaryArgumentsType
) => (ComposedComponent: React.ComponentType): React.ComponentClass =>
  class WithErrorBoundary extends React.Component {
    // eslint-disable-next-line react/state-in-constructor
    public state: ErrorBoundaryStateType;

    constructor(props: ErrorBoundaryPropsType) {
      super(props);
      this.state = {
        hasError: false
      };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
      this.setState({
        hasError: true,
        error
      },
      async () => {
        await reportUIError(componentTitle, info?.componentStack, error);
      }
      );
    }

    render(): React.ReactNode {
      const { hasError, error } = this.state;
      return hasError ? (
        <ErrorComponent fallbackAction={ fallbackAction } error={ error } />
      ) : (
        <ComposedComponent { ...this.props } />
      );
    }
  };
